import { MasterDataResponse } from "./models/MasterDataModel";
import { ServiceAndItemResponse } from "./models/ServiceAndItemModel";

export const GetAllBlackList = async (): Promise<BlackListModel> => {
  const response = await fetch("api/CatalogMasterData/MasterData/BlackList", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((res) => res.json())
    .then((result) => {
      return result;
    });
  return response as BlackListModel;
};

export const GetAllExecutivePosition =
  async (): Promise<MasterDataResponse> => {
    const response = await fetch(
      "api/CatalogMasterData/MasterData/ExecutivePosition",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => res.json())
      .then((result) => {
        return result;
      });

    return response as MasterDataResponse;
  };

export const GetAllCharaterics = async (): Promise<MasterDataResponse> => {
  const response = await fetch(
    "api/CatalogMasterData/MasterData/Characteristics",
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  )
    .then((res) => res.json())
    .then((result) => {
      return result;
    });
  return response as MasterDataResponse;
};

export const GetAllTitleName = async (): Promise<MasterDataResponse> => {
  const response = await fetch("api/CatalogMasterData/MasterData/TitleName", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((res) => res.json())
    .then((result) => {
      return result;
    });
  return response as MasterDataResponse;
};

export const GetAllServiceAndItem =
  async (): Promise<ServiceAndItemResponse> => {
    const response = await fetch("api/CatalogMasterData/ServiceAndItem", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((result) => {
        return result;
      });
    return response as ServiceAndItemResponse;
  };

  export const GetCategoryDepartment = async (departmentCode: string) => {
    const response = await fetch("api/CatalogMasterData/GetCategoryDepartment?departmentCode" + departmentCode, {
      method: "GET",
    })
      .then((res) => res.json())
      .then((result) => {
        return result;
      }).catch((err) => {
        return err;
      });
    return response;
  };

  export const InsertCategoryDepartment = async (dataJson: any) => {
    const respone = await fetch("api/CatalogMasterData/InsertCategoryDepartment", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataJson),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((err) => {
        return err;
      });
  
    return respone;//.filter((e: any) => e.IsActive === true);
  };
  export const DeleteCategoryDepartment = async (dataJson: any) => {
    const respone = await fetch("api/CatalogMasterData/DeleteCategoryDepartment", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataJson),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((err) => {
        return err;
      });
  
    return respone;//.filter((e: any) => e.IsActive === true);
  };

  export const GetMasterBudget = async () => {
    const response = await fetch("api/CatalogMasterData/GetMasterBudget", {
      method: "GET",
    })
      .then((res) => res.json())
      .then((result) => {
        return result;
      }).catch((err) => {
        return err;
      });
    return response;
  };
  export const InsertMasterBudget = async (dataJson: any) => {
    const respone = await fetch("api/CatalogMasterData/InsertMasterBudget", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataJson),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((err) => {
        return err;
      });
  
    return respone;
  };
  export const UpdateMasterBudget = async (dataJson: any) => {
    const respone = await fetch("api/CatalogMasterData/UpdateMasterBudget", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataJson),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((err) => {
        return err;
      });
  
    return respone;
  };
  export const DeleteMasterBudget = async (dataJson: any) => {
    const respone = await fetch("api/CatalogMasterData/DeleteMasterBudget", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataJson),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((err) => {
        return err;
      });
  
    return respone;
  };
  export const UpdateCategoryItemStock = async (dataJson: any) => {
    const respone = await fetch("api/CatalogMasterData/UpdateCategoryItemStock", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataJson),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((err) => {
        return err;
      });
  
    return respone;
  };

  export const GetEmployeeInfoForCatalog = async (dataJson: any) => {
    const respone = await fetch("api/CatalogMasterData/GetEmployeeInfoForCatalog", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataJson),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((err) => {
        return err;
      });
  
    return respone;
  };

  export const GetEmployeeInfoForCatalogByEmpId = async (dataJson: any) => {
    const respone = await fetch("api/CatalogMasterData/GetEmployeeInfoForCatalogByEmpId", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataJson),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((err) => {
        return err;
      });
  
    return respone;
  };

  
  